export default "__VITE_ASSET__6ebd6a91__"